import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { ThankYouElementDataType } from '@/components/sections/builder/elements/body/thankyou/type';
import ImageSetting from '@/components/sections/builder/settings/image-setting';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Separator } from '@/components/ui/separator';
import { Switch } from '@/components/ui/switch';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSettingThankyou({ element }: ElementProps) {
  const data = element.data as ThankYouElementDataType;

  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  return (
    <div>
      <h1 className='mb-3 text-sm font-bold'>Content Settings</h1>
      <h3 className='my-2 text-xs'>Label</h3>
      <TextEditorMinimal
        value={data.labelThankyou}
        onChange={(val) => {
          builder.setElementData(element.id, {
            labelThankyou: val,
          });
        }}
        output='html'
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
      />
      <h3 className='my-2 text-xs'>Button Label</h3>
      <TextEditorMinimal
        value={data.labelButton}
        onChange={(val) => {
          builder.setElementData(element.id, {
            labelButton: val,
          });
        }}
        output='html'
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
      />
      <div className='my-4 flex items-center gap-2'>
        <label>Enable swipe on mobile</label>
        <Switch
          checked={data.showHomeButton}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              showHomeButton: !!checked,
            });
          }}
          className='ml-auto'
          aria-readonly
        />
      </div>
      <Separator className='my-4' />
      <h1 className='mb-3 text-sm font-bold'>Images Settings</h1>
      <div className='mb-4 mt-4 text-xs'>Image</div>
      <ImageSetting
        value={data?.imageUrl}
        onChange={(val) =>
          builder.setElementData(element.id, {
            imageUrl: val,
          })
        }
      />
      <InputSlider
        label='Images Width'
        value={data?.imageWidth || 100}
        max={500}
        min={50}
        onChange={(val) => {
          builder.setElementData(element?.id as string, {
            imageWidth: val,
          });
        }}
      />
      <Separator className='my-4' />
      <h1 className='mb-3 text-sm font-bold'>Style </h1>
      <div className='mb-2 mt-4 '>Color scheme</div>
      <SchemeSetting
        value={data.colorScheme}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorScheme: theme,
          });
        }}
      />
    </div>
  );
}
